var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("editor", {
    staticClass: "my-editor",
    attrs: {
      "is-document": true,
      disabled: true,
      "default-val": _vm.defaultEditorVal
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };